import { useEffect, useState } from 'react';
import { DesContent } from '../DescriptionModal/Description.styled';
import { DistAreaProps } from './distArea.props';
import { CheckBox, Div, Label, Retangle, WhiteRetangle } from './distArea.styled';

const DistAreaModal = ({ firmAvailData, serviceId,tab }: DistAreaProps) => {

    const [selectedValue, setSelectedValue] = useState<number>(0);
    const [filterValue, setFilterValue] = useState<any[]>();

    const handleClick = (value: number) => {
        setSelectedValue(value!);
    }
    const displayLevel = (level: number) => {
        switch (level) {
            case 4:
                return (
                    <>
                        <Retangle />
                        <WhiteRetangle />
                        <WhiteRetangle />
                        <WhiteRetangle />
                    </>
                )
            case 3:
                return (
                    <>
                        <Retangle />
                        <Retangle />
                        <WhiteRetangle />
                        <WhiteRetangle />
                    </>
                )
            case 2:
                return (
                    <>
                        <Retangle />
                        <Retangle />
                        <Retangle />
                        <WhiteRetangle />
                    </>
                )
            case 1:
                return (
                    <>
                        <Retangle />
                        <Retangle />
                        <Retangle />
                        <Retangle />
                    </>
                )
            default:
                return (
                    <>
                        <WhiteRetangle />
                        <WhiteRetangle />
                        <WhiteRetangle />
                        <WhiteRetangle />
                    </>
                )
        }
    }

    const filterServiceLevel = (level: number) => {
        if (level !== 0) {
            const rs = firmAvailData.comFirmPracticeLevel!.filter(x => x.fkPracticeLevelId === level)
            setFilterValue(rs!);
        }
        else {
            setFilterValue(firmAvailData.comFirmPracticeLevel!);
        }
    }

    useEffect(() => {
        filterServiceLevel(selectedValue!)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValue, firmAvailData])

    useEffect(() => {
        setSelectedValue(0);
    }, [serviceId])
    
    return (
        <Div className="dis-area-container w-full">
            {
                firmAvailData &&
                <DesContent className="description">
                    {tab === "service" ?
                        <Div className="select-comp mobile2:pl-[5px]">
                            <Div className="check-box">
                                <CheckBox type="radio" id="show-all" name="fav_language" value="showall" checked={!selectedValue} onChange={() => { }} onClick={() => {
                                    handleClick(0);
                                    setFilterValue(firmAvailData.comFirmPracticeLevel!);
                                }}
                                />
                                <Label className="check-box-lable" htmlFor="show-all"
                                    onClick={() => {
                                        handleClick(0)
                                        setFilterValue(firmAvailData.comFirmPracticeLevel!);
                                    }}
                                >Show All</Label>
                            </Div>
                            <Div className="check-box">
                                <CheckBox type="radio" id="startup" name="fav_language" value="startup" onClick={() => {
                                    handleClick(4)
                                }} />
                                <Label className="check-box-lable" htmlFor="startup"
                                    onClick={() => {
                                        handleClick(4)
                                    }}>Startup</Label>
                            </Div>
                            <Div className="check-box">
                                <CheckBox type="radio" id="novice" name="fav_language" value="novice" onClick={() => {
                                    handleClick(3)
                                }} />
                                <Label className="check-box-lable" htmlFor="novice"
                                    onClick={() => {
                                        handleClick(3)
                                    }}>Novice</Label>
                            </Div>
                            <Div className="check-box">
                                <CheckBox type="radio" id="stablished" name="fav_language" value="established" onClick={() => {
                                    handleClick(2)
                                }} />
                                <Label className="check-box-lable" htmlFor="stablished"
                                    onClick={() => {
                                        handleClick(2)
                                    }}>Established</Label>
                            </Div>
                            <Div className="check-box">
                                <CheckBox type="radio" id="advanced" name="fav_language" value="advanced" onClick={() => {
                                    handleClick(1)
                                }} />
                                <Label className="check-box-lable" htmlFor="advanced"
                                    onClick={() => {
                                        handleClick(1)
                                    }}>Advanced</Label>
                            </Div>
                        </Div> : null
                    }
                    <Div className="line" style={{ borderBottom: "5px" }} />
                    {
                        filterValue === undefined ? firmAvailData.comFirmPracticeLevel!.map((e, index) => {
                            return (
                                <Div className='services' key={index} style={{ display: "flex" }}>
                                    <Div className='level'>
                                        {
                                            displayLevel(e.fkPracticeLevelId!)
                                        }
                                    </Div>
                                    <p className='p-service ml-[5px] text-[#637381]'> {e.fkSecondaryService?.secondaryServiceName}</p>
                                </Div>
                            )
                        }) :
                            filterValue!.map((e, index) => {
                                return (
                                    <Div className='services' key={index} style={{ display: "flex" }}>
                                        <Div className='level'>
                                            {
                                                displayLevel(e.fkPracticeLevelId!)
                                            }
                                        </Div>
                                        <p className='p-service ml-[5px] text-[#637381]'> {e.fkSecondaryService?.secondaryServiceName}</p>
                                    </Div>
                                )
                            })
                    }
                    {tab === "product" && <Div className="select-comp mobile2:pl-[5px]"></Div>}
                    {
                        tab === "product" && firmAvailData && firmAvailData.comOfferingProductSecondary!.map((e, index) => {
                            
                            return (
                                <>
                                    <Div className='products' key={index} style={{ display: "flex" }}>
                                        <Div className='level'>
                                        </Div>
                                        <p className='p-service'> {e.fkSecondaryService?.secondaryServiceName}</p>
                                    </Div>
                                </>
                            )
                        })
                    }
                </DesContent >
            }
        </Div>
    )
}

export default DistAreaModal;